import { memo } from 'react';
import { useModal } from 'root/src/client/v2/common/contexts/modal.context';
import { ModalLayout } from 'root/src/client/v2/common/layouts/ModalLayout';
import modalSuccessImg from 'root/src/client/public/modalSuccessImg.png';
import { ButtonNew } from 'root/src/client/v2/common/components/form/ButtonNew';
export const PendingProjectModal = memo(() => {
    const modal = useModal();
    return (<ModalLayout>
			<div className="flex flex-col gap-6 justify-center items-center">
				<h1 className="text-2xl font-bold text-center text-teal">Success</h1>
				<h2 className="text-lg text-center font-medium">Waiting for admin approval</h2>
				<img src={modalSuccessImg.src} alt="Success" className="w-36 h-36"/>
				<span className="font-bold text-center">Reward will be sent after approval by the administrator</span>
				<ButtonNew className="uppercase font-bold px-8" onClick={() => modal.hide()}>Ok</ButtonNew>
			</div>
		</ModalLayout>);
});
